<template>
  <div class="p-4 m-5 border bg-white">
    <div
      class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between"
    >
      <!-- Left side -->
      <div class="flex items-center gap-2">
        <Funnel class="w-5 h-5 text-blue-600" />
        <span class="text-blue-800 font-medium">
          {{ translate("general.filtered_by_merchant", pageLang) }}:
          <span class="font-bold">{{ props.merchantId }}</span>
        </span>
      </div>

      <!-- Clear button -->
      <VButton class="flex items-center gap-2" @click="handleClearFilter()">
        <closeIcon class="w-4 h-4" />
        {{ translate("general.clear_filter", pageLang) }}
      </VButton>
    </div>
  </div>
</template>

<script setup lang="ts">
// Import Vue Packages
import { ref } from "vue"
import { X as closeIcon, Funnel } from "lucide-vue-next"

// Import Vue Custom Components
import { translate } from "src/utils/translation"
import { LOCAL_STORAGE_KEYS } from "src/utils/localStorageKeys"

// Props & Emits
const props = defineProps<{
  merchantId: string;
}>()

const emit = defineEmits(["clearFilter"])

// Variables
const pageLang = ref(localStorage.getItem(LOCAL_STORAGE_KEYS.PREFERENCES.LANG) || "ar")

// Functions
const handleClearFilter = () => emit("clearFilter")
</script>
